module.exports = __webpack_public_path__ + "img/accelerator-2.8943cb22.png";